<template>

    <div class="SC-split__col" v-if="matches.length > 0">

        <div class="caption caption--assoc">{{type}}</div>

            <div class="Results-matches">

            <score-card v-for="match in matches"
                        :match="match"
                        v-if="showMatch(match)"
                        :flagPath="flagPath"
                        :key="match.id"
                        mode="result"
                        :detail="detail"
                        :data-id="match.id">
            </score-card>

        </div>

        <div class="go-more">
            <a :href="results + '?assoc=' + type">View {{type}} results</a>
        </div>

    </div>

</template>

<script>
    import axios from 'axios'
    import MatchCard from './MatchCard.vue'

    export default {
        components: {
            'score-card': MatchCard,
        },
        props: ['featured', 'type', 'flag', 'detail', 'results'],
        data() {
            return {
                feed: [],
                matches: [],
                flagPath: this.flag + '/assets/dist/svg/flags/',
                featuredMatches: this.featured.split(',')
            }
        },
        created() {
            let ip = this.determineFeedUrl()

            axios.get(`${ip}/get/${this.type}/draws`).then(response => {

                this.feed = response.data

                let allMatches = this.getAllMatchesInOneArray(response.data)
                let finishedMatches = this.getOnlyFinishedMatches(allMatches)

                if ( this.featured != '' ) {

                    this.matches = this.getOnlyFeaturedMatches(finishedMatches)

                } else {

                    this.matches = finishedMatches.reverse().slice(0, 2)

                }
            }).catch(function (error) {
                console.log(error);
            });
        },
        methods: {
            getOnlyFinishedMatches(matches) {
                return matches.filter(function(match) {

                    return match.detail.state == 'F'

                })

            },
            getOnlyFeaturedMatches(matches) {
                return matches.filter(match => this.featuredMatches.includes(match.id))
            },
            getAllMatchesInOneArray(feed) {
                let allMatches = []

                for (let event of feed) {
                    for (let round of event.rounds) {
                        allMatches.push(...round.matches)
                    }
                }

                return allMatches
            },
            determineFeedUrl() {

                if (this.type == 'atp') {
                    return window.atp_ip
                } else {
                    return window.wta_ip
                }

            },
            showMatch(match) {
                if (!match.detail) {
                    return false
                }

                if (match.detail.state == 'F') {
                    return true
                }
            }
        }

    }
</script>